module.exports = [{"value":"มกราคม","text":"มกราคม"},{"value":"กุมภาพันธ์","text":"กุมภาพันธ์"},{"value":"มีนาคม","text":"มีนาคม"},{"value":"เมษายน","text":"เมษายน"},{"value":"พฤษภาคม","text":"พฤษภาคม"},{"value":"มิถุนายน","text":"มิถุนายน"},{"value":"กรกฎาคม","text":"กรกฎาคม"},{"value":"สิงหาคม","text":"สิงหาคม"},{"value":"กันยายน","text":"กันยายน"},{"value":"ตุลาคม","text":"ตุลาคม"},{"value":"พฤศจิกายน","text":"พฤศจิกายน"},{"value":"ธันวาคม","text":"ธันวาคม"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/Date/monthNameTH.json
// module id = Lyoh
// module chunks = 2